type ClientConfig = Readonly<{
  url: string;
}>;

/**
 * Base URL every generated SDK client is pointed at.
 *
 * Lives in its own module so the non-React token helpers (`spoofSession`,
 * `userTokenRefresh`) can read it without importing `authUtils`, which imports
 * them back. Re-exported from `authUtils` so existing client imports keep working.
 */
export const clientConfig: ClientConfig = {
  url: import.meta.env.VITE_AUTH_URL ?? 'http://localhost',
};
